import { createSelector } from '@lumapps/redux/reselect';

export const analyticsInfoSelector = (state: FrontOfficeStore) => state.analyticsInfo || {};

export const userDirectoriesCodeValuesSelector = createSelector(
    analyticsInfoSelector,
    (info) => info?.userDirCodeValues ?? [],
);
